// extracted by mini-css-extract-plugin
export default {"map":"style_map__yUbxH"};